import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import PaymentTypeForm from './PaymentTypeForm';

export class PaymentTypeUpdateForm extends FormView {
    protected getFormComponent() {
        return PaymentTypeForm;
    }
}

export default PaymentTypeUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(PaymentTypeUpdateForm));
